import bugsnagClient from './bugsnag';
// eslint-disable-next-line
import store from '../store/index';
import bugsnagSeverity from '../utils/enums/bugsnagSeverity';

export default (err, severity = bugsnagSeverity.ERROR) => {
  const error = err instanceof Error ? err : new Error(err);
  const { response } = error;
  // Check if it is an axios error
  // If so, reset the stacktrace, default axios stack trace is not very helpful
  if (response && response.config && response.config.isAxios) {
    const stackTrace = new Error().stack;
    // Remove the log referencing here
    // messes up bugsnag grouping if we don't remove
    if (stackTrace) {
      const arr = stackTrace.split('\n'); // create an array with all lines
      // Some browsers may format the stack differently
      if (arr[0].substring(0, 5) === 'Error') {
        arr.splice(1, 1); // remove the second line (first line after "Error")
      } else {
        arr.splice(0, 1); // remove the first line
      }
      error.stack = arr.join('\n');
    }
  }
  bugsnagClient.notify(error, {
    metaData: {
      error_response: {
        data: response ? response.data : null,
        request: response ? response.request : null,
        status: response ? response.status : null,
      },
      user: {
        user: store.state.user,
        business: store.state.business,
      },
    },
    severity,
  });
};
